import { useState } from 'react';
import { Home, Sprout, Compass, TreePine, BookOpen, ShoppingBag, Flame, Mail } from 'lucide-react';
import { Navigation } from '@/components/Navigation';
import { HeroSection } from '@/components/HeroSection';
import { OfflineMinuteExperience, experienceThemes } from '@/components/OfflineMinuteExperience';
import { AboutSection } from '@/components/AboutSection';
import { ServicesSection } from '@/components/ServicesSection';
import { ContactSection } from '@/components/ContactSection';
import { UpcomingExperiencesSection } from '@/components/UpcomingExperiencesSection';
import { MysticStoreSection } from '@/components/MysticStoreSection';
import { BlogSection } from '@/components/BlogSection';
import { LeaderSection } from '@/components/LeaderSection';
import { Footer } from '@/components/Footer';
import { SEO } from '@/components/SEO';

import { PageNavigation } from '@/components/PageNavigation';

const Index = () => {
  const [isOfflineExperienceActive, setIsOfflineExperienceActive] = useState(false);
  const [currentThemeIndex, setCurrentThemeIndex] = useState(0);

  const handleStartOfflineExperience = () => {
    setIsOfflineExperienceActive(true);
    // Rotate to next theme for next time
    setCurrentThemeIndex((prev) => (prev + 1) % experienceThemes.length);
  };
  const navigationSections = [
    { id: 'main-content', label: 'Home', icon: Home },
    { id: 'about', label: 'Our Roots', icon: Sprout },
    { id: 'services', label: 'What We Offer', icon: Compass },
    { id: 'experiences', label: 'Experiences', icon: TreePine },
    { id: 'blog', label: 'Blog', icon: BookOpen },
    { id: 'store', label: 'Shop', icon: ShoppingBag },
    { id: 'leader', label: 'Join the Club', icon: Flame },
    { id: 'contact', label: 'Contact', icon: Mail },
  ];

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Mystic Forest",
    "url": "https://mysticforest.club",
    "logo": "https://mysticforest.club/og-image.jpg",
    "description": "Curated analog experiences, mindful retreats, and workshops in nature.",
    "sameAs": [
      "https://www.instagram.com/mysticforest.club"
    ],
    "contactPoint": {
      "@type": "ContactPoint",
      "email": "hello@mysticforest.club",
      "contactType": "Customer Service"
    }
  };

  return (
    <>
      <SEO
        title="Mystic Forest - Offline is the New Luxury"
        description="Discover curated analog experiences, mindful retreats, and workshops in nature. Join digital detox retreats, men's and women's circles, forest bathing, yoga, and slow cooking workshops. Reconnect with yourself, build authentic connections, and rediscover balance away from screens."
        canonicalUrl="https://mysticforest.club/"
        keywords={['digital detox', 'nature retreats', 'mindfulness workshops', 'forest bathing', 'offline experiences', 'wellness retreats', 'mens retreat', 'womens retreat', 'yoga retreat', 'analog experiences']}
        jsonLd={jsonLd}
      />
      
      <div className="min-h-screen bg-background relative">
        <PageNavigation sections={navigationSections} />
        
        
        <div className="relative z-20">
          <Navigation />
          <main>
            <HeroSection onStartOfflineExperience={handleStartOfflineExperience} />
            <AboutSection />
            <ServicesSection />
            <UpcomingExperiencesSection />
            <BlogSection />
            <MysticStoreSection />
            <LeaderSection />
            <ContactSection />
          </main>
          <Footer />
        </div>
        
      <OfflineMinuteExperience 
        isActive={isOfflineExperienceActive} 
        onClose={() => setIsOfflineExperienceActive(false)}
        theme={experienceThemes[currentThemeIndex]}
      />
      </div>
    </>
  );
};

export default Index;
